import React, { ComponentProps } from 'react';

import { Route } from 'react-router-dom';
import { NoPermission } from 'src/components/NoPermission';
import { Role } from 'src/constants';
import { UNIVERSAL_ROLE_SET } from 'src/constants/role';
import { AppContext } from 'src/contexts/appContext';

interface IProtectedRouteProps extends ComponentProps<any> {
    requiredRoleSet?: Set<Role>;
}

export const ProtectedRoute = ({ requiredRoleSet = UNIVERSAL_ROLE_SET, ...componentProps }: IProtectedRouteProps) => {
    const { userRole } = React.useContext(AppContext);

    return requiredRoleSet.has(userRole) ? <Route {...componentProps} /> : <Route component={NoPermission} />;
};
